import React, { Component } from "react";
import Link from "@material-ui/core/Link";
import "./CountiesList.css";

import { ReactComponent as PottyMegyek } from "../../img/potty_megyek.svg";

class CountiesList extends Component {
  render() {
    const { disableConties } = this.props;
    return (
      <React.Fragment>
        {this.props.counties.map((county) => {
          return (
            <React.Fragment key={"link-" + county.name + "-" + county.id}>
              <div
                className={
                  "countyIcon" +
                  (this.props.active.id === county.id ||
                  this.props.activeRegions.find((e) => {
                    return e === county.id;
                  })
                    ? " active"
                    : "")
                }
              >
                <PottyMegyek
                  fill={
                    this.props.hoverCounty === county.id ? "#b6dcd5" : "#dfdfdf"
                  }
                />
                {!disableConties && county.id !== "==" ? (
                  <span className="coutieLink">{county.name}</span>
                ) : (
                  <Link
                    id={county.id}
                    className="coutieLink"
                    disabled="disabled"
                    href="#"
                    onClick={() => this.props.SetCounty(county)}
                    onMouseEnter={this.props.HoverCountyEnter}
                    onMouseLeave={this.props.HoverCountyLeave}
                  >
                    {county.name}
                  </Link>
                )}
              </div>
            </React.Fragment>
          );
        })}
      </React.Fragment>
    );
  }
}

export default CountiesList;
